import { render } from "./VerticalAlignment.vue?vue&type=template&id=7f57070e"
import script from "./VerticalAlignment.vue?vue&type=script&lang=js"
export * from "./VerticalAlignment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__